const uiReducerInitialState = {
  action: "show",
  saving: false,
  resident_updated_at: null,
  dischargeModal: {
    occupancy: {},
    action: 'new',
    show: false,
    is_submitting: false,
    errors: [],
  },
  pastOccupancyModal: {
    occupancy: {},
    action: "new",
    show: false
  },
  currentOccupancyModal: {
    occupancy: {},
    action: "new",
    show: false
  },
  vaccineModal: {
    vaccine: {},
    action: "new",
    show: false
  },
  testModal: {
    test: { },
    action: 'new',
    show: false,
  },
  educationModal: {
    education: {},
    action: "new",
    show: false
  },
  insuranceModal: {
    insurance: {},
    action: "new",
    show: false
  },
  treatmentCenterModal: {
    treatmentCenter: {},
    action: "new",
    show: false
  },
  occupationModal: {
    occupation: {},
    action: "new",
    show: false
  },
  therapistModal: {
    therapist: {},
    action: "new",
    show: false
  },
  livingArrangementHistoryModal: {
    livingArrangementHistory: {},
    action: "new",
    show: false
  },
  probationModal: {
    probation: {},
    action: "new",
    show: false
  },
  abuseExperienceModal: {
    abuseExperience: {},
    action: "new",
    show: false
  },
  sobrietyModal: {
    sobriety: {},
    action: "new",
    show: false
  },
  contactModal: {
    contact: {},
    action: "new",
    show: false
  },
  familyMemberModal: {
    familyMember: {},
    action: "new",
    show: false
  },
  publicBenefitModal: {
    publicBenefit: {},
    action: "new",
    show: false
  },
  programHistoryModal: {
    programHistory: {},
    action: "new",
    show: false
  },
  documentModal: {
    document: {},
    action: "new",
    show: false
  },
  medicationModal: {
    medication: {},
    action: "new",
    show: false
  },
  transactionModal: {
    transaction: {},
    action: "new",
    show: false
  },
  soberLivingModal: {
    soberLiving: {},
    action: "new",
    show: false
  },
  demographicsModal: {
    show: false
  },
  criminalHistoryModal: {
    show: false,
    criminalHistory: {}
  },
  medicinalMarijuanaModal: {
    show: false,
    medicinalMarijuana: {}
  },
  medicalHistoryModal: {
    show: false
  },
  recoveryHistoryModal: {
    show: false
  },
  paymentsModal: {
    show: false
  },
  generalModal: {
    show: false
  },
  sendSMSModal: {
    show: false
  },
  refillModal: {
    show: false,
    refill: {
      name: null
    }
  },
  passwordResetModal: {
    show: false,
    completed: false,
    error: undefined
  },
  signUpCodeModal: {
    show: false,
    error: undefined,
    complete: false,
    signUpCode: undefined,
    signUpCodeCreated: undefined
  },
  errorModal: {
    show: false,
    errors: {}
  },
  counselingHistoryModal: {
    counselingHistory: {},
    action: "new",
    show: false
  },
  childWelfareHistoryModal: {
    childWelfareHistory: {},
    action: "new",
    show: false
  }
};

export default (state = uiReducerInitialState, action) => {
  switch (action.type) {
    case "FAILED_DISCHARGE_RESIDENT_FORM":
      return {
        ...state,
        dischargeModal: {
          ...state.dischargeModal,
          is_submitting: false,
          errors: action.payload
        }
      }
    case "OPEN_DISCHARGE_OCCUPANCY_MODAL":
      return {
        ...state,
        dischargeModal: {
          ...state.dischargeModal,
          occupancy: action.payload,
          action: "edit",
          show: true
        }
      }
    case "CLOSE_DISCHARGE_OCCUPANCY_MODAL":
      return {
        ...state,
        dischargeModal: uiReducerInitialState.dischargeModal
      }
    case "BEGIN_DISCHARGE_RESIDENT_FORM":
      return {
        ...state,
        dischargeModal: {
          ...state.dischargeModal,
          is_submitting: true,
        }
      }
    case "SUCCESS_DISCHARGE_RESIDENT_FORM":
      return {
        ...state,
        dischargeModal: uiReducerInitialState.dischargeModal
      }

    case "NEW_INSURANCE":
      return {
        ...state,
        insuranceModal: {
          ...state.insuranceModal,
          insurance: {},
          action: "new",
          show: true
        }
      };
    case "EDIT_INSURANCE":
      return {
        ...state,
        insuranceModal: {
          ...state.insuranceModal,
          insurance: action.payload,
          action: "edit",
          show: true
        }
      };
    case "UPDATE_INSURANCE_FIELD":
      return {
        ...state,
        insuranceModal: {
          ...state.insuranceModal,
          insurance: {
            ...state.insuranceModal.insurance,
            [action.payload.name]: action.payload.value
          }
        }
      };
    case "CLOSE_INSURANCE_FORM_MODAL":
      return {...state, insuranceModal: {...state.insuranceModal, show: false}};

    case "NEW_EDUCATION":
    return {
      ...state,
      educationModal: {
        ...state.educationModal,
        education: {},
        action: "new",
        show: true
      }
    };
    case "EDIT_EDUCATION":
      return {
        ...state,
        educationModal: {
          ...state.educationModal,
          education: action.payload,
          action: "edit",
          show: true
        }
      };
    case "UPDATE_EDUCATION_FIELD":
      return {
        ...state,
        educationModal: {
          ...state.educationModal,
          education: {
            ...state.educationModal.education,
            [action.payload.name]: action.payload.value
          }
        }
      };
    case "CLOSE_EDUCATION_FORM_MODAL":
      return {...state, educationModal: {...state.educationModal, show: false}};
    case "TOGGLE_ACTION":
      return {...state, action: state.action == "show" ? "edit" : "show"};
    case "CLOSE_OCCUPANCY_FORM_MODAL":
      return {...state, pastOccupancyModal: {...state.pastOccupancyModal, show: false}};
    case "CLOSE_CURRENT_OCCUPANCY_FORM_MODAL":
      return {...state, currentOccupancyModal: {...state.currentOccupancyModal, show: false}};
    case "CLOSE_VACCINE_FORM_MODAL":
      return {...state, vaccineModal: {...state.vaccineModal, show: false}};
    case "NEW_VACCINE":
      return {
        ...state,
        vaccineModal: {
          ...state.vaccineModal,
          show: true,
          vaccine: {},
          action: "new",
        }
      };
    case "EDIT_VACCINE":
      return {
        ...state,
        vaccineModal: {
          ...state.vaccineModal,
          vaccine: action.payload,
          action: "edit",
          show: true
        }
      };
    case "UPDATE_VACCINE_FIELD":
      return {
        ...state,
        vaccineModal: {
          ...state.vaccineModal,
          vaccine: {
            ...state.vaccineModal.vaccine,
            [action.payload.name]: action.payload.value
          }
        }
      };

    case "CLOSE_VACCINE_FORM_MODAL":
      return {...state, vaccineModal: {...state.vaccineModal, show: false}};
    case "NEW_VACCINE":
      return {
        ...state,
        vaccineModal: {
          ...state.vaccineModal,
          show: true,
          vaccine: {},
          action: "new",
        }
      };
    case "EDIT_VACCINE":
      return {
        ...state,
        vaccineModal: {
          ...state.vaccineModal,
          vaccine: action.payload,
          action: "edit",
          show: true
        }
      };
    case "UPDATE_VACCINE_FIELD":
      return {
        ...state,
        vaccineModal: {
          ...state.vaccineModal,
          vaccine: {
            ...state.vaccineModal.vaccine,
            [action.payload.name]: action.payload.value
          }
        }
      };

    case "CLOSE_TEST_FORM_MODAL":
      return {...state, testModal: {...state.testModal, show: false}};
    case "NEW_TEST":
      return {
        ...state,
        testModal: {
          ...state.testModal,
          show: true,
          test: {},
          action: "new",
        }
      };
    case "EDIT_TEST":
      return {
        ...state,
        testModal: {
          ...state.testModal,
          test: action.payload,
          action: "edit",
          show: true
        }
      };
    case "UPDATE_TEST_FIELD":
      return {
        ...state,
        testModal: {
          ...state.testModal,
          test: {
            ...state.testModal.test,
            [action.payload.name]: action.payload.value
          }
        }
      };
    case "NEW_OCCUPANCY":
      return {
        ...state,
        pastOccupancyModal: {
          ...state.pastOccupancyModal,
          occupancy: {},
          action: "new",
          show: true
        }
      };
    case "EDIT_OCCUPANCY":
      return {
        ...state,
        pastOccupancyModal: {
          ...state.pastOccupancyModal,
          occupancy: action.payload,
          action: "edit",
          show: true
        }
      };
    case "UPDATE_OCCUPANCY_FIELD":
      return {
        ...state,
        pastOccupancyModal: {
          ...state.pastOccupancyModal,
          occupancy: {
            ...state.pastOccupancyModal.occupancy,
            [action.payload.name]: action.payload.value
          }
        }
      };
      case "NEW_CURRENT_OCCUPANCY":
        return {
          ...state,
          currentOccupancyModal: {
            ...state.currentOccupancyModal,
            occupancy: {},
            action: "new",
            show: true
          }
        };
      case "EDIT_CURRENT_OCCUPANCY":
        return {
          ...state,
          currentOccupancyModal: {
            ...state.currentOccupancyModal,
            occupancy: action.payload,
            action: "edit",
            show: true
          }
        };
      case "UPDATE_CURRENT_OCCUPANCY_FIELD":
        return {
          ...state,
          currentOccupancyModal: {
            ...state.currentOccupancyModal,
            occupancy: {
              ...state.currentOccupancyModal.occupancy,
              [action.payload.name]: action.payload.value,
              [action.payload.name + '_field_updated']: true
            }
          }
        };
    case "OPEN_RESOURCE_MODAL":
      return {
        ...state,
        [`${action.payload.resourceName}Modal`]: {
          ...state[`${action.payload.resourceName}Modal`],
          show: true
        }
      }
    case "CLOSE_RESOURCE_MODAL":
      return {
        ...state,
        [`${action.payload.resourceName}Modal`]: {
          ...state[`${action.payload.resourceName}Modal`],
          show: false
        }
      }
    case "NEW_RESOURCE":
      return {
        ...state,
        [`${action.payload.resourceName}Modal`]: {
          ...state[`${action.payload.resourceName}Modal`],
          [action.payload.resourceName]: {},
          action: "new",
          show: true
        }
      }
    case "EDIT_RESOURCE":
      return {
        ...state,
        [`${action.payload.resourceName}Modal`]: {
          ...state[`${action.payload.resourceName}Modal`],
          [action.payload.resourceName]: action.payload.resource,
          action: "edit",
          show: true
        }
      }
    case "UPDATE_RESOURCE_FIELD":
      return {
        ...state,
        [`${action.payload.resourceName}Modal`]: {
          ...state[`${action.payload.resourceName}Modal`],
          [action.payload.resourceName]: {
            ...state[`${action.payload.resourceName}Modal`][action.payload.resourceName],
            [action.payload.name]: action.payload.value
          }
        }
      }
    case "UPDATE_SAVING":
      return {
        ...state,
        saving: action.payload.saving
      }
    case "UPDATE_RESIDENT_UPDATED_AT":
      return {
        ...state,
        resident_updated_at: action.payload.resident_updated_at
      }
    case "PASSWORD_RESET_SUCCESS":
      return {
        ...state,
        passwordResetModal: {
          ...state.passwordResetModal,
          completed: true,
        }
      }
    case "PASSWORD_RESET_FAILED":
      return {
        ...state,
        passwordResetModal: {
          ...state.passwordResetModal,
          completed: true,
          error: action.payload.error
        }
      }
    case "SIGN_UP_GENERATION_SUCCESS":
      return {
        ...state,
        signUpCodeModal: {
          ...state.signUpCodeModal,
          completed: true,
          signUpCode: action.payload.signUpCode,
          signUpCodeCreated: action.payload.signUpCodeCreated
        }
      }
    case "UPDATE_ERRORS": {
      return {
        ...state,
        errorModal: {
          ...state.errorModal,
          errors: action.payload.errors
        }
      }
    }
    default:
      return state;
  }
}
